import ErrorTemplate from "../../components/error-template";
import { Button } from "@acesso-io/genoma-ui";
import { useTranslation } from '@frontend/feature-i18n';
import PropTypes from 'prop-types';
import AppErrorIcon from '../../../assets/images/AppErrorIcon.svg';
import { NEW_TAB_REL, NEW_TAB_TARGET } from "../../utils/constants";
import { primaryButtonStyles, secondaryButtonStyles } from "./styles";

const DEFAULT_HELP_URL = "https://empresas.unico.io/hc/pt-br";

const Error5xx = ({ helpUrl = DEFAULT_HELP_URL }) => {
  const { getTranslationAsString } = useTranslation();

  const handleTryAgain = () => {
    window.location.reload();
  };

  const handleSupport = () => {
    window.open(helpUrl, NEW_TAB_TARGET, NEW_TAB_REL);
  };

  return (
    <ErrorTemplate
      errorCode='5xx'
      image={AppErrorIcon}
      imageClassName='error-icon'
      title={getTranslationAsString('SystemMisbehaved', {}, 'Tivemos um erro ao carregar esta página')}
      actions={
        <>
          <Button
            variant="contained"
            onClick={handleTryAgain}
            sx={primaryButtonStyles}
          >
            {getTranslationAsString('TryAgain', {}, 'Tentar novamente')}
          </Button>
          <Button
            variant="text"
            onClick={handleSupport}
            sx={secondaryButtonStyles}
          >
            {getTranslationAsString('Support', {}, 'Suporte')}
          </Button>
        </>
      }
    >
      <span>
        {getTranslationAsString(
          "ContactSupport",
          {},
          "Você pode tentar novamente atualizando a página. Se o erro persistir, entre em contato com nosso suporte."
        )}
      </span>
    </ErrorTemplate>
  );
};

Error5xx.propTypes = {
  helpUrl: PropTypes.string,
};

export default Error5xx;
